// How an imported lead row identifies its vehicle. UK imports key on the registration; a VIN-keyed
// yard's rows carry a VIN and may have no plate at all, so a row with either identifier is worth
// importing and the dedup key falls back from the plate to the VIN.
import { normaliseVin } from "./vehicleIdentifier";
import { normaliseVrm } from "./vehicleScan";

export interface ImportVehicleIdentity {
  Vrm?: string | null;
  Vin?: string | null;
}

/** The first non-blank value under any of the usual VIN column headings. */
export const readVinColumn = (row: Record<string, unknown>): string | undefined => {
  for (const key of ["VIN", "Vin", "vin", "Chassis", "ChassisNo", "Chassis No", "Chassis Number"]) {
    const value = row[key];
    if (typeof value === "string" && value.trim()) return value.trim();
    if (typeof value === "number") return String(value);
  }

  return undefined;
};

/** True when the row names a vehicle by plate or by VIN. */
export const hasVehicleIdentifier = (vehicle: ImportVehicleIdentity | null | undefined): boolean =>
  !!vehicle && (normaliseVrm(vehicle.Vrm).length > 0 || normaliseVin(vehicle.Vin).length > 0);

/** The dedup key for an imported row: the plate, else the VIN, else undefined. */
export const leadImportCcid = (vehicle: ImportVehicleIdentity | null | undefined): string | undefined => {
  if (!vehicle) return undefined;

  const vrm = normaliseVrm(vehicle.Vrm);
  if (vrm) return vrm;

  const vin = normaliseVin(vehicle.Vin);
  return vin || undefined;
};
